import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { notificationService } from '../services/apiClient';
import NotificationDropdown from './NotificationDropdown';
import { Bell } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user) {
      fetchUnreadCount();
      const interval = setInterval(fetchUnreadCount, 30000); // Check every 30s
      return () => clearInterval(interval);
    }
  }, [user]);

  const fetchUnreadCount = async () => {
    try {
      const response = await notificationService.getNotifications();
      setUnreadCount(response.data.unreadCount || 0);
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="text-2xl font-bold text-purple-600"
          >
            COLLEGESPHERE
          </button>

          <div className="flex items-center gap-4 md:gap-6 text-sm md:text-base">
            <button onClick={() => navigate('/dashboard')} className="text-gray-700 hover:text-purple-600 transition-colors hidden sm:block">
              Home
            </button>
            <button onClick={() => navigate('/membership')} className="text-gray-700 hover:text-purple-600 transition-colors hidden sm:block">
              Membership
            </button>
            <button onClick={() => navigate('/forum')} className="text-gray-700 hover:text-purple-600 transition-colors hidden sm:block">
              Forum
            </button>

            {/* Notification Bell */}
            {user && (
              <div className="relative">
                <button
                  onClick={() => setIsNotifOpen(!isNotifOpen)}
                  className="p-2 text-gray-600 hover:text-purple-600 transition relative"
                >
                  <Bell className="w-5 h-5 md:w-6 md:h-6" />
                  {unreadCount > 0 && (
                    <span className="absolute top-0 right-0 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white transform translate-x-1/4 -translate-y-1/4">
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}
                </button>
                <NotificationDropdown
                  isOpen={isNotifOpen}
                  onClose={() => setIsNotifOpen(false)}
                />
              </div>
            )}

            {(user?.role === 'ClubAdmin' || user?.role === 'SuperAdmin') && (
              <button
                onClick={() => navigate(user.role === 'SuperAdmin' ? '/super-admin' : '/admin')}
                className="text-purple-600 font-bold hover:text-purple-800 transition-colors"
              >
                {user.role === 'SuperAdmin' ? 'Terminal' : 'Admin'}
              </button>
            )}

            <button onClick={() => navigate('/profile')} className="text-gray-700 hover:text-purple-600 transition-colors hidden md:block">
              Profile
            </button>
            <button onClick={handleLogout} className="text-gray-700 hover:text-red-600 transition-colors">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
